module.exports = __webpack_public_path__ + "img/pt.3b3b8788.svg";